// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box {
  animation: moving-box 1.5s ease-in-out infinite;
}
.center-slider {
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes moving-box {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
  100% {
    transform: translateY(0);
  }
}

.icon_share {
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
}

.input {
    width: 100%;
    height: 40px;
    outline: none !important;
    padding: 20px;
    border: 1px solid #E5E7EB;
    border-radius: 8px;
    transition: 0.5s all ease-in-out;
    font-size: 16px;
}

.input:focus {
    border: 1px solid #3C1FAB;
}
.svg path {
  fill: #fff
}
.svgWhite rect {
  fill: #fff
}
.svgWhite rect,
.svgWhite path {
  fill: #fff
}
/* .primary path {
  fill: #3C1FAB
} */
.test fieldset{
  border: none !important;
}
.myDate{width: 100%;}
.react-datepicker-wrapper {width: 100%; margin: 8px 0;}
.react-datepicker__input-container .react-datepicker__calendar-icon {left:0}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;AACA;EACE;AACF;AACA;EACE;AACF;AACA;;EAEE;AACF;AACA;;GAEG;AACH;EACE,uBAAuB;AACzB;AACA,QAAQ,WAAW,CAAC;AACpB,2BAA2B,WAAW,EAAE,aAAa,CAAC;AACtD,qEAAqE,MAAM","sourcesContent":[".box {\n  animation: moving-box 1.5s ease-in-out infinite;\n}\n.center-slider {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n@keyframes moving-box {\n  0% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-5px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n\n.icon_share {\n  border-radius: 50%;\n  width: 2rem;\n  height: 2rem;\n}\n\n.input {\n    width: 100%;\n    height: 40px;\n    outline: none !important;\n    padding: 20px;\n    border: 1px solid #E5E7EB;\n    border-radius: 8px;\n    transition: 0.5s all ease-in-out;\n    font-size: 16px;\n}\n\n.input:focus {\n    border: 1px solid #3C1FAB;\n}\n.svg path {\n  fill: #fff\n}\n.svgWhite rect {\n  fill: #fff\n}\n.svgWhite rect,\n.svgWhite path {\n  fill: #fff\n}\n/* .primary path {\n  fill: #3C1FAB\n} */\n.test fieldset{\n  border: none !important;\n}\n.myDate{width: 100%;}\n.react-datepicker-wrapper {width: 100%; margin: 8px 0;}\n.react-datepicker__input-container .react-datepicker__calendar-icon {left:0}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
